import { Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'

export const InfoCenterPageTabs = ({ currentTab }: { currentTab: any }) => {
  return (
    <Tabs value={currentTab}>
      <Tab
        label="Newsletters"
        value={`/InfoCenter/NewslettersPage`}
        to={`/InfoCenter/Newsletters`}
        component={Link}
      />
      <Tab
        label="News"
        value={`/InfoCenter/NewsPage`}
        to={`/InfoCenter/News`}
        component={Link}
      />
      <Tab
        label="Resources"
        value={`/InfoCenter/ResourcesPage`}
        to={`/InfoCenter/Resources`}
        component={Link}
      />
    </Tabs>
  )
}
